import { render } from "./Impact.vue?vue&type=template&id=28c44316&scoped=true"
import script from "./Impact.vue?vue&type=script&lang=js"
export * from "./Impact.vue?vue&type=script&lang=js"

import "./Impact.vue?vue&type=style&index=0&id=28c44316&scoped=true&lang=css"

import exportComponent from "/Users/agroinnovatech/Development/Agro-Innova/AgroInnovaWebsite/AgroInnovaWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c44316"]])

export default __exports__